/**
 * Split editorial section — reveal only.
 *
 * @package HelloElementorChild
 */

import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

export function initCamstSplitEditorial(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-split-editorial]'));
  } else if (scope.matches && scope.matches('[data-camst-split-editorial]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-split-editorial]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstSplitEditorialInit === '1') {
      return;
    }

    root.dataset.camstSplitEditorialInit = '1';
    initCamstReveal(root);
  });
}

export function teardownCamstSplitEditorial(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-split-editorial]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-split-editorial]'));

  roots.forEach(function (root) {
    teardownCamstReveal(root);
    delete root.dataset.camstSplitEditorialInit;
  });
}
